import { Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Spin from 'antd/es/spin';

import ProtectedRoute from '../components/ProtectedRoute';
import { installFormStoreUrlListener } from '../store/form/formStoreUrlListener';
import AppShell from './AppShell';
import RootLayout from './RootLayout';
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import FormPage from '../pages/FormPage';
import EntitiesPage from '../pages/EntitiesPage';
import SearchPage from '../pages/SearchPage';
import NotificationsPage from '../pages/NotificationsPage';
import {
  ErrorPage,
  PasswordResetPage,
  DesktopAuthPage,
  FormsPage,
  AnalyticsPage,
  LedgerPage,
  SettingsPage,
  APIsPage,
  ArchivePage,
  ErrorTestingPage,
  ValtioDebugPage,
  IntakePage,
  IntakeSchedulePage,
  IntakePricebookPage,
} from './lazyPages';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: (
      <AppShell>
        <Suspense fallback={<Spin size="large" fullscreen />}>
          <ErrorPage />
        </Suspense>
      </AppShell>
    ),
    children: [
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '/password-reset',
        element: (
          <Suspense fallback={<Spin size="large" fullscreen />}>
            <PasswordResetPage />
          </Suspense>
        ),
      },
      {
        path: '/desktop-auth',
        element: (
          <Suspense fallback={<Spin size="large" fullscreen />}>
            <DesktopAuthPage />
          </Suspense>
        ),
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: '/',
            element: <HomePage />,
          },
          {
            path: '/forms',
            element: <FormsPage />,
          },
          {
            path: '/forms/:formId',
            element: <FormPage />,
          },
          {
            path: '/forms/:formId/formVersions/:versionId',
            element: <FormPage />,
          },
          {
            path: '/entities',
            element: <EntitiesPage />,
          },
          {
            path: '/entities/:entityId',
            element: <EntitiesPage />,
          },
          {
            path: '/entities/:entityId/records/:recordId',
            element: <EntitiesPage />,
          },
          {
            path: '/search',
            element: <SearchPage />,
          },
          {
            path: '/analytics',
            element: <AnalyticsPage />,
          },
          {
            path: '/ledger',
            element: <LedgerPage />,
          },
          {
            path: '/ledger/:ledgerId',
            element: <LedgerPage />,
          },
          {
            path: '/apis',
            element: <APIsPage />,
          },
          {
            path: '/notifications',
            element: <NotificationsPage />,
          },
          {
            path: '/settings/*',
            element: <SettingsPage />,
          },
          {
            path: '/intake',
            element: <IntakePage />,
          },
          {
            path: '/intake/schedules/:jobId',
            element: <IntakeSchedulePage view="cells" />,
          },
          {
            path: '/intake/schedules/:jobId/columns',
            element: <IntakeSchedulePage view="columns" />,
          },
          {
            path: '/intake/pricebooks/:editionId',
            element: <IntakePricebookPage view="review" />,
          },
          {
            path: '/intake/pricebooks/:editionId/compare',
            element: <IntakePricebookPage view="compare" />,
          },
          {
            path: '/intake/pricebooks/:editionId/pages/:page/columns',
            element: <IntakePricebookPage view="columns" />,
          },
          {
            path: '/archive',
            element: <ArchivePage />,
          },
          {
            path: '/error-testing',
            element: <ErrorTestingPage />,
          },
          {
            path: '/valtio-debug',
            element: <ValtioDebugPage />,
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/" />,
      },
    ],
  },
]);

installFormStoreUrlListener(router);
